import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SmoothCollapse from 'react-smooth-collapse';
import CopyButton from '../CopyButton';
import Button from '../Button';
import CodeBlock from '../CodeBlock';

var CodeExample =
/*#__PURE__*/
function (_Component) {
  _inherits(CodeExample, _Component);

  function CodeExample() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CodeExample);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CodeExample)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      open: _this.props.initialOpen
    });

    return _this;
  }

  _createClass(CodeExample, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var code = this.props.code;
      return React.createElement("div", {
        className: "row"
      }, React.createElement("div", {
        className: "col-md-12",
        style: {
          paddingTop: '10px'
        }
      }, React.createElement(SmoothCollapse, {
        expanded: this.state.open
      }, React.createElement(CodeBlock, {
        code: code
      })), React.createElement("div", {
        className: "clearfix"
      }, React.createElement(Button, {
        type: "link",
        onClick: function onClick() {
          return _this2.setState(function (prevState) {
            return {
              open: !prevState.open
            };
          });
        },
        className: "pull-right"
      }, this.state.open ? 'Hide code' : 'Show code'), this.state.open ? React.createElement(CopyButton, {
        style: {
          marginRight: '9px'
        },
        type: "link",
        className: "pull-right",
        toCopy: code
      }) : null)));
    }
  }]);

  return CodeExample;
}(Component);

export { CodeExample as default };
CodeExample.propTypes = {
  code: PropTypes.string,
  initialOpen: PropTypes.bool
};
CodeExample.defaultProps = {
  initialOpen: true
};